import { render, staticRenderFns } from "./FortnoxArticleList.vue?vue&type=template&id=16d94e38"
import script from "./FortnoxArticleList.vue?vue&type=script&lang=ts"
export * from "./FortnoxArticleList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports